import { useEffect, useState } from 'react';
import { AdvancedFilterButton } from '@/components/common/AdvancedFilter';
import { PageHeader } from '@/components/layout/PageHeader';
import { useDebounce } from '@/hooks/useDebounce';

interface InstituteSubmissionListHeaderProps {
  appliedSearchText: string;
  onSearchApply: (value: string) => void;
  filterOpen: boolean;
  onFilterToggle: () => void;
  activeFilterCount: number;
}

export function InstituteSubmissionListHeader({
  appliedSearchText,
  onSearchApply,
  filterOpen,
  onFilterToggle,
  activeFilterCount,
}: InstituteSubmissionListHeaderProps) {
  const [searchText, setSearchText] = useState(appliedSearchText);
  const [seenAppliedSearchText, setSeenAppliedSearchText] = useState(appliedSearchText);
  const debouncedSearchText = useDebounce(searchText);

  if (appliedSearchText !== seenAppliedSearchText) {
    setSeenAppliedSearchText(appliedSearchText);
    if (appliedSearchText !== debouncedSearchText.trim()) setSearchText(appliedSearchText);
  }

  useEffect(() => {
    onSearchApply(debouncedSearchText);
  }, [debouncedSearchText, onSearchApply]);

  return (
    <PageHeader
      title="Institute Submissions"
      search={{
        value: searchText,
        onChange: setSearchText,
        placeholder: 'Institute, Code, EIIN, ZM',
      }}
      actions={
        <AdvancedFilterButton
          isOpen={filterOpen}
          activeCount={activeFilterCount}
          onClick={onFilterToggle}
        />
      }
    />
  );
}
